import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject, takeUntil } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TodoService } from 'app/modules/admin/dashboard/todo/todo.service'; 
import { TodoItem } from 'app/modules/admin/dashboard/dashboard.types';
import { LookupItem } from 'app/model/lookup.model';
export interface CampNotesDialogData {
  campId: string;
  campName: string;
  users: LookupItem[];
  todo?: TodoItem; // optional (for edit mode)
}
@Component({
  selector: 'app-notes-detail',
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
  templateUrl: './detail.component.html',
  styles: ``
})
export class CampNotesDetailComponent {
  notesForm: FormGroup;
  isSubmitting = false;
  isEditMode = false;
  todos: TodoItem[] = [];
  roles: LookupItem[] = [];
  users: LookupItem[] = [];
  private readonly _unsubscribeAll = new Subject<void>();
  constructor(
    private readonly _formbuilder: FormBuilder,
    private dialogRef: MatDialogRef<CampNotesDetailComponent>,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _todoService: TodoService,
    @Inject(MAT_DIALOG_DATA) public data: CampNotesDialogData
  ) {
    this.users = this.data.users || []; // assign injected users to local variable for template access
    this.isEditMode = !!this.data.todo;
    this.notesForm = this._formbuilder.group({
      notes: [this.data.todo?.notes || '', Validators.required],
      isCompleted: [this.data.todo?.isCompleted || false],
      assignedTo: [this.data.todo?.assignedTo || this.data.todo?.createdBy || '', Validators.required]
    });
  }



  save(): void {
    if (this.notesForm.invalid) return;
    const raw = this.notesForm.getRawValue();

    let todoPayload: any;

    if (this.isEditMode && this.data.todo) {

      // UPDATE MODE
      todoPayload = {
        id: this.data.todo.id,
        notes: raw.notes,
        isCompleted: raw.isCompleted,
        campId: this.data.campId,
        completedDate: raw.isCompleted
          ? (this.data.todo.completedDate ?? new Date().toISOString())
          : null,
        completedBy: raw.isCompleted
          ? this.data.todo.completedBy ?? null
          : null,
        assignedTo: raw.assignedTo ?? null
      };
    }
    else {
      // CREATE MODE
      todoPayload = {
        notes: raw.notes,
        isCompleted: raw.isCompleted,
        campId: this.data.campId,
        assignedTo: raw.assignedTo ?? ""
      };
    }
    this.dialogRef.close(todoPayload); // return created item
  }

  close() {
    this.dialogRef.close();
  }


  toggleStatus(event: any, todo: TodoItem): void {
    const newStatus = event.checked;
    // Optimistic update
    todo.isCompleted = newStatus;
    this._cdr.markForCheck();

    this._todoService
      .updateTodoStatus(todo.id, newStatus)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: () => {
          this._todoService.notifyTodoUpdate('update', todo);
        },
        error: () => {
          // Revert on failure
          todo.isCompleted = !newStatus;
          this._cdr.markForCheck();
        },
      });
  }

  trackByFn( item: any) {
    return item?.id ?? item;
  }

}
